import { useTraduccion } from '@tallerya/i18n';

// La entrada de la consola. Hoy dice qué va a haber y nada más: sin números ni
// tarjetas de mentira, por la misma razón que el inicio del admin.
export function Inicio() {
  const { t } = useTraduccion();

  return (
    <>
      <h1>{t('plataforma.inicio.titulo')}</h1>
      <p className="entrada">{t('plataforma.inicio.entrada')}</p>

      <section className="aviso">
        <h2>{t('plataforma.inicio.aviso.titulo')}</h2>
        <p>{t('plataforma.inicio.aviso.texto')}</p>
      </section>
    </>
  );
}
